import * as IMG from '@Utils/Images';
import clsx from 'classnames';

export default function Component(props) {
  const { image, loading } = props;

  return (
    <>
      <div
        className={clsx('detail-img-header', {
          'placeholder': loading
        })}
        style={{ backgroundImage: `url(${image || IMG.EMPTY})` }}
      />
      <div className="detail-img-small row m-0 ms-2">
        <div className="col-3 p-0">
          <button className="w-100">
            <div
              className={clsx('img', {
                'placeholder': loading
              })}
              style={{
                backgroundImage: `url(${IMG.EMPTY})`,
              }}
            />
          </button>
        </div>

        <div className="col-3 p-0">
          <button className="w-100">
            <div
              className={clsx('img', {
                'placeholder': loading
              })}
              style={{ backgroundImage: `url(${IMG.EMPTY})` }}
            />
          </button>
        </div>

        <div className="col-3 p-0">
          <button className="w-100">
            <div
              className={clsx('img', {
                'placeholder': loading
              })}
              style={{ backgroundImage: `url(${IMG.EMPTY})` }}
            />
          </button>
        </div>

        <div className="col-3 p-0">
          <button className="w-100">
            <div
              className={clsx('img', {
                'placeholder': loading
              })}
              style={{ backgroundImage: `url(${IMG.EMPTY})` }}
            />
          </button>
        </div>
      </div>
    </>
  );
}